import React from 'react';
import './VenueAnalysisBar.scss';
import { VenueAnalysisAggregatedLiquidityItem } from 'widgets/venueAnalysis/venueAnalysisAggregatedData';
import { VenueAnalysisBar } from 'widgets/venueAnalysis/grid/VenueAnalysisBar';
import { VenueAnalysisVenueDisplayData } from 'widgets/venueAnalysis/grid/gridData';

interface OrderLiquidityBarProps {
    data: VenueAnalysisAggregatedLiquidityItem;
    width: number;
}

export function OrderLiquidityBar(props: OrderLiquidityBarProps) {
    const { data, width } = props;

    const barData: VenueAnalysisVenueDisplayData = {
        name: data.liquidity.name,
        micCode: data.liquidity.name,
        barWidth: data.percent,
        percent: data.percent,
        qty: data.qty,
    };

    return (
        <VenueAnalysisBar
            width={width}
            className={data.liquidity.className}
            data={barData}
            showVenues={false}
            highlightOnHover={true}
        />
    );
}
